import React from 'react';

const ChatIcon = () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="chat-icon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9089 11.091C10.9089 10.6893 11.2345 10.3637 11.6361 10.3637H13.818V1.63643H2.1816V10.3637H8.38641C9.03393 10.3637 9.648 10.6513 10.0625 11.1488L10.9089 12.1644V11.091ZM12.3634 14.0001C12.3634 14.6803 11.5129 14.9882 11.0774 14.4657L8.94512 12.0799C8.80694 11.9141 8.60225 11.8182 8.38641 11.8182H1.45432C1.05266 11.8182 0.727051 11.4926 0.727051 11.091V0.909158C0.727051 0.507496 1.05266 0.181885 1.45432 0.181885H14.5452C14.9469 0.181885 15.2725 0.507496 15.2725 0.909157V11.091C15.2725 11.4926 14.9469 11.8182 14.5452 11.8182H12.3634V14.0001Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.81805 5.99984C5.81805 6.60234 5.32963 7.09075 4.72714 7.09075C4.12465 7.09075 3.63623 6.60234 3.63623 5.99984C3.63623 5.39735 4.12465 4.90894 4.72714 4.90894C5.32963 4.90894 5.81805 5.39735 5.81805 5.99984ZM9.09078 5.99984C9.09078 6.60234 8.60236 7.09075 7.99987 7.09075C7.39737 7.09075 6.90896 6.60234 6.90896 5.99984C6.90896 5.39735 7.39737 4.90894 7.99987 4.90894C8.60236 4.90894 9.09078 5.39735 9.09078 5.99984ZM11.2726 7.09075C11.8751 7.09075 12.3635 6.60234 12.3635 5.99984C12.3635 5.39735 11.8751 4.90894 11.2726 4.90894C10.6701 4.90894 10.1817 5.39735 10.1817 5.99984C10.1817 6.60234 10.6701 7.09075 11.2726 7.09075Z"
      fill="white"
    />
  </svg>
);

export default ChatIcon;
